import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 1rem;
  font-weight: 500;
  font-size: 0.8rem;

  .correlatos-title {
    display: flex;
    align-items: center;
    gap: 0.4rem;
    color: var(--primary_color);
  }
`;
